/**
 * Game Controller Class
 *
 * Handles the main game flow
 *
 * Also has some specific cascade reels functionality here
 */

/* module manages the main game this inherits from spinFunctions */

gameController = (function () {
  var _payWinsEvent = {};
  var _poppingSymbols = [];
  var _dropEvent = [];
  var _dropsRemaining = 0;
  var _reelToFrespinsBarFlying = 0;
  var _reelToFrespinsBarFlyingMax = 0;
  var _popAndDropCompleteEvent = 0;
  var _totalWinnings = 0;
  var _numberOfPops = 0;
  var _jackpotTask;
  var _gameCompleteEvent;
  var _featureAwarded = false;
  var _animWinsFinished = false;
  var _recoveryTask;

  var _bonusesLanded = 0;

  var _isPrePaid = false;
  var _inRecovery = false;

  var _skipWin = false;
  var _bonusSymbolsLanded = 0;
  var _initialDropping = 0;
  var logoIdleTimeline = undefined;

  var _isPromotion = false;

  var _bigWin = undefined;
  var _inBuyABonus = false;
  var _popData = [];
  var _allPopsComplete;
  var _wildAppearSymbols = [];

  var _symbolDisappearAnims = [];
  var _landedAnimsPlaying = [];
  var _bonusSymsOnTop = [];
  var _bonusSymsDropComplete = false;
  var _symbolCallbackFired = [];

  var _lantern = undefined;
  var _freeSpinsMeter = undefined;

  var _topReelSpinCount = 0;

  var _modifierEventTriggered = false;

  var _spinBonusSounds = [
    "bonusLand1",
    "bonusLand2",
    "bonusLand3",
    "bonusLand4",
    "bonusLand5",
  ];

  var _lowWinSounds = ["smallWin1", "smallWin2", "smallWin3"];
  var _highWinSounds = ["highWin1", "highWin2", "highWin3"];

  var rng;

  function resetWinnings() {
    _totalWinnings = 0;
    _numberOfPops = 0;
  }

  function jackpotGame(task) {
    _jackpotTask = task;
    _jackpotTask.join();

    _bigWin.start(task.data.value, function () {
      _jackpotTask.leave();
    });
  }

  /**
   * This function also handles the replay
   */
  function recoverGame(task) {
    // Recovery game with encore
    _inRecovery = true;
    gameController.inRecovery = true;
    resourceManager.get("helpPageScroll").close();
    if (
      task.data.metaData === "encore" &&
      gameData.encoreEnabled !== task.data.metaValue
    ) {
      // Clear any encore effects and stop them appearing again
      gameData.encoreEnabled = task.data.metaValue;

      // Put button in the right state if not already true
      var encoreButtonLB = resourceManager.get(
        "buttonContainer:buttonBar:luckyBetToggleButton"
      );

      if (gameData.encoreEnabled) {
        resourceManager.getContainer(
          "goldenBetBackgroundContainer"
        ).visible = true;
      }

      if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }
    }

    if (task.data.metaData === "buyABonus" && task.data.metaValue) {
      const stakeController = resourceManager.getController("stakeController");
      gameController.inBuyABonus = true;
      gameController.bonusBetStake = task.data.bpl;

      let baseStake = gameData.recoveryStake;

      if (baseStake === undefined) {
        baseStake = stakeController.currentStake;
      }
      stakeController.setStakeMultiplier(1);

      let stakes = stakeController.Stakes;
      let returnStake = stakes.find((stake) => stake === baseStake);

      if (!returnStake) {
        returnStake = stakes[0];
      }

      stakeController.requestChangeStake(returnStake);
      stakeController.requestChangeStake(baseStake, "BONUS_BUY");

      gameData.stakeMeter.set(baseStake);
    } else {
      initNewSpin();

      // Update stake
      let stakeController = resourceManager.getController("stakeController");

      let baseStake = stakeController.BaseStake;
      let bpl = baseStake / stakeController.CurrentWinLineCount; // appears unused
      let luckyBetEnabled = gameData.encoreEnabled;

      stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
      game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1), bpl);
      stakeController.broadcastCurrentStake();
    }
  }

  function onPromotionStarted() {
    _isPromotion = true;
  }

  function onPromotionEnded() {
    _isPromotion = false;
  }

  function canEnableSkip() {
    return (
      gameController.stateMachine.ActiveStateName === "PAYWINS" && !_skipWin
    );
  }

  function initNewSpin() {
    gameController.resetTopSpinCount();
    // Start of new game
    gameController._receivedResponse = false;

    gameController.hideSymbolAnims();
    gameController.resetWinnings();

    resourceManager
      .get("buttonContainer:buttonBar:luckyBetToggleButton")
      .hideMessage();

    musicManager.onGameStart();

    gameController.reelsSpinning = [false, false, false, false, false]; //gameData.reels.length;
    gameData.winningsMeter.set(0);

    var config = resourceManager.get("slotContainer").Props.configValues;

    gameData.reels.forEach(function (value) {
      value.setSpinParameters({
        spinSpeed: config.spinSpeed,
        landOffset: config.landOffset,
        decelerationDistance: config.decelerationDistance,
      });
    });

    _payWinsEvent = undefined;
    gameController.spinTask = undefined;

    // clear reels here - then spin event will cause the new symbols to drop in
    slotMachine.clearReels();

    // this needs to go to an intermediate state until the drop is finished - then into reels_spinning
    //gameController.stateMachine.switchState("REELS_SPINNING");
    gameController.stateMachine.switchState("CLEAR_REELS");

    // Update autoplay button text
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr =
      spinsRemaining > 0 ? String(spinsRemaining - 1) : "∞";

    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", spinsRemainingStr);
  }

  function startGame() {
    let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");
    if (buyBonusPopUp.visible) return;

    initNewSpin();

    var stakeController = resourceManager.getController("stakeController");
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

    gdk.startGame(
      {
        //numbers should came from the stake controller
        stake: stakeController.CurrentStake,
        numWinlines: stakeController.CurrentWinLineCount,
        bpl: bpl,
        metaData: {
          encore: gameData.encoreEnabled,
          buyABonus: false,
        },
      },
      function () {
        gdk.getNextGameOutcome(function () {});
      }
    );
  }

  function onAbortGame() {
    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);

    // game aborted - reset reels to startup symbols
    for (var i = 0; i < slotMachine.reels.length; i++) {
      let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
      let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
      let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

      // Copy starting symbols from server
      for (var j = 0; j < reelLength; ++j) {
        reel.setReelSymbol(j, startingSymbols[j].value);

        // make sure the reel symbols are in the correct position
        reel.dropInitialSymbols(j, 1);
      }

      // just for completeness the off screen symbol
      reel.dropInitialSymbols(3, 1);
    }

    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }

  //TODO
  function doPayWins(payWinsEvent) {
    _payWinsEvent = payWinsEvent;
    _payWinsEvent.join();
    _numberOfPops++;

    /// TODO SA Win levels may need tweaking
    if (!freespins.inFreespins /*!freespins.areFreeSpinsActive()*/) {
      if (_numberOfPops >= 3) {
        musicManager.fadeLevels(
          musicManager.REALLYBIGWINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut,
          1,
          0
        );
      } else if (_numberOfPops === 2) {
        musicManager.fadeLevels(
          musicManager.MULTIWINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut,
          1,
          0
        );
      } else if (_numberOfPops === 1) {
        musicManager.fadeLevels(
          musicManager.SINGLEWINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut,
          1,
          0
        );
      }
    } else {
      // we do this once all cascades have finished on this spin
      //musicManager.freeSpinsNextLevel();
    }

    // Add to cumulative total winnings
    _skipWin = false;
    _totalWinnings += _payWinsEvent.data.totalLineWinnings;

    gameController.canCelebrate =
      _totalWinnings >
      resourceManager.getController("stakeController").CurrentStake;

    _extraSpinsFlyingToTotem = 0;

    gameController.stateMachine.switchState("PAYWINS");
  }

  function onModifierEvent() {
    _modifierEventTriggered = true;
  }

  function preGameComplete(gameCompleteEvent) {
    doGameComplete();
  }

  function doGameComplete() {
    if (!_isPrePaid && !gameController._inRecovery) {
      gameData.creditMeter.set(gameData.credit + _totalWinnings);
    }

    if (gameController.inBuyABonus) {
      const sp = gdk.getServerParser();
      const inReplayOrRewatch = sp._inReplayMode || sp._inRewatchMode;
      if (!inReplayOrRewatch) {
        // restore the original stake
        let stakeController = resourceManager.getController("stakeController");
        stakeController.broadcastCurrentStake("default");
      }
    }

    gameController.inBuyABonus = false;

    _lantern.resetMultiplier();

    if (!musicManager.wasInFreespins) {
      musicManager.onGameEnd();
    } else {
      musicManager.wasInFreespins = false;
    }

    //resourceManager.get( "fairy" ).onIdle();

    gameController.stateMachine.switchState("END_GAME");
  }

  function autoplayStarted(autoplayData) {
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining >= 0 ? String(spinsRemaining) : "X";

    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", spinsRemainingStr);
    // winlineManager.enableWinlinesTouch(false);
  }

  function autoplayEnded(autoplayData) {
    // winlineManager.enableWinlinesTouch(true);
    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", "");
    resourceManager.get(
      "buttonContainer:buttonBar:autoplayButton:glow"
    ).visible = false;
  }

  function onPopAndDropComplete(popAndDropCompleteEvent) {
    _popAndDropCompleteEvent = popAndDropCompleteEvent;

    if (popAndDropCompleteEvent.data.winnings > 0) {
      _popAndDropCompleteEvent.join();
      gameController.stateMachine.switchState("PAY_TO_WINNINGS");
    }

    if (reelManager.reels[0].symbolData[3].symbolId == 9) {
      reelManager.reels[0].children[0].children[3].visible = false;
    }
    if (reelManager.reels[1].symbolData[3].symbolId == 9) {
      reelManager.reels[1].children[0].children[3].visible = false;
    }
    if (reelManager.reels[2].symbolData[3].symbolId == 9) {
      reelManager.reels[2].children[0].children[3].visible = false;
    }
    if (reelManager.reels[3].symbolData[3].symbolId == 9) {
      reelManager.reels[3].children[0].children[3].visible = false;
    }
    if (reelManager.reels[4].symbolData[3].symbolId == 9) {
      reelManager.reels[4].children[0].children[3].visible = false;
    }
  }

  function onDropEvent(dropEvent) {
    _topReelSpinCount++;
    _dropEvent = dropEvent;
    _dropEvent.join();

    _bonusSymsDropComplete = false;

    gameController.stateMachine.switchState("DROP_SYMBOLS");

    // Spin top reel
    timerManager.addTimer(1000, undefined, function () {
      let topReel = resourceManager.get("slotContainer:TopReel");
      topReel.dropSymbols(dropEvent.data.cells);
      topReel.doSpin(topReel.data, _topReelSpinCount);
    });
  }

  function onExtraSpinsRemaining(event) {}

  async function onDropComplete() {
    _dropsRemaining--;

    if (_dropsRemaining === 0) {
      await waitForTopReel();
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      _dropEvent.leave();
    }
  }

  async function waitForTopReel() {
    await gameController.topRowFinished;
  }

  function onReelToFrespinsBarComplete() {
    _reelToFrespinsBarFlying--;
    if (_reelToFrespinsBarFlying === 0) {
      // Move onto next phase
      _allPopsComplete = true;
    }
  }

  function onFeatureAnnounced(task) {
    _featureAwarded = true;
    if (gameController.inBuyABonus) {
      _totalWinnings = 0;
    }
    freespins.setInitialWinnings(_totalWinnings);
    logoIdleTimeline.pause();
  }

  function onFeatureEnded() {
    _featureAwarded = false;
  }

  function update(delta, time) {
    this.stateMachine.update();
  }

  function dimAllReels(dim, duration = 0.3) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, duration);
    }
  }

  //define gameController
  gameController = Object.create(spinFunctions);
  Object.defineProperties(gameController, {
    startGame: { value: startGame },
    resetWinnings: { value: resetWinnings },
    initNewSpin: { value: initNewSpin },
    totalWinnings: { value: _totalWinnings },
    doGameComplete: { value: doGameComplete },
    canEnableSkip: { value: canEnableSkip },
    isFeatureAwarded: {
      get: function () {
        return _featureAwarded;
      },
    },
    dimAllReels: { value: dimAllReels },
    inBuyABonus: {
      get: function () {
        return _inBuyABonus;
      },
      set: function (value) {
        _inBuyABonus = value;
      },
    },
    inRecovery: {
      get: function () {
        return _inRecovery;
      },
      set: function (value) {
        _inRecovery = value;
      },
    },
    topRowFinished: {
      get: function () {
        return topRowFinished;
      },
      set: function (value) {
        topRowFinished = value;
      },
    },
  });

  gameController.resetTopSpinCount = function () {
    _topReelSpinCount = 0;
  };

  gameController.resetSymbolCallbackFired = function () {
    _symbolCallbackFired = [];
  };

  gameController.hideSymbolAnims = function () {
    for (let i = 0; i < 5; i++) {
      let animStrip = resourceManager.get(
        reelManager.reels[i].linkedAnimations[0].name
      );
      animStrip.hideAllAnimations();
      animStrip.removeChildren();
    }
  };

  gameController.hideSingleSymbolAnim = function (reel, row) {
    let animStrip = resourceManager.get(
      reelManager.reels[reel].linkedAnimations[0].name
    );
    animStrip.hideAnimation(row);
    if (animStrip.children[row] !== undefined) {
      animStrip.children[row].visible = false;
    }
  };

  /**
   * Set up the win flash animations
   *
   * We position it when we play it to allow for different orientaitonons, not on creation
   */

  gameController.setupSymbolDisappearAnims = function () {
    for (let i = 0; i < 5; i++) {
      let rowAnims = [];

      for (var j = 0; j < 3; j++) {
        let movie = resourceManager.createObject(
          "movie",
          "symbolDisappear_" + i + "_" + j,
          "reelsParticleLayer",
          {
            definition: "symbolFlash",
            x: 0,
            y: 0,
            anchor: 0.5,
            loop: false,
            scale: 1.0,
          }
        );
        movie.gotoAndStop(0);
        rowAnims.push(movie);
      }

      _symbolDisappearAnims.push(rowAnims);
    }
  };

  // The symbols are not always in numnerical order so use this to get the correct order.
  gameController.getUpdatedSymbolOrder = function (reel) {
    const symbolOrder = [];
    const symbolContainer = resourceManager.get(
      "slotContainer:reelContainer:reel" + reel + ":symbolContainer"
    );
    const symbols = [];

    for (let i = 0; i < symbolContainer.children.length; i++) {
      const symbol = resourceManager.get(
        "slotContainer:reelContainer:reel" +
          reel +
          ":symbolContainer:symbol" +
          i
      );
      symbols.push({ y: symbol.transform.position.y, index: i });
    }

    symbols.sort((a, b) => a.y - b.y);

    for (let i = 0; i < symbols.length; i++) {
      symbolOrder.push(symbols[i].index);
    }

    return symbolOrder;
  };

  gameController._receivedResponse = false;

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(gameController);

  gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

  gameController.stateMachine.addState("WAIT_FOR_START", function () {
    if (gameController.phase.once()) {
      resourceManager.getController("autoplayController").checkLimits();
    }
    if (gameController.phase.hold()) {
      if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
        gameController.phase.step();
      }
    }
    if (gameController.phase.hold()) {
      // Waiting for player to do something
      if (autoplayManager.isAutoplayEnabled()) {
        if (
          autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
          autoplayManager.AP.roundsRemaining()
        ) {
          var timeToNext = 500;
          resourceManager.getController(
            "autoplayController"
          ).timeToNextAutoplay = timeToNext;
          gameController.phase.step();
        }
      }
    }
    if (
      gameController.phase.timed(
        resourceManager.getController("autoplayController").timeToNextAutoplay
      )
    ) {
      if (!autoplayManager.isAutoplayEnabled()) {
        gameController.phase.reset();
      }
    }
    if (gameController.phase.once()) {
      startGame();
    }
  });

  gameController.initialDropComplete = function (reelID) {
    --_initialDropping;
  };

  gameController.stateMachine.addState("CLEAR_REELS", function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count
    if (gameController.phase.enter()) {
      _initialDropping = gameData.reels.length;
    }

    // TODO 23/05/22 this needs to hold until all initial reels are dropped AND the spin task has been received
    if (gameController.phase.hold()) {
      if (_initialDropping === 0) {
        gameController.phase.step();
      }
    }

    // drop intial symbols needs to have finished before we do spin task leave and the symbols should all have landed
    if (gameController.phase.once()) {
      //gameController.stateMachine.switchState("REELS_SPINNING");
      gameController.stateMachine.switchState("DROP_INITIAL_SYMBOLS");
    }
  });

  gameController.stateMachine.addState("DROP_INITIAL_SYMBOLS", function () {
    if (gameController.phase.hold()) {
      // don't proceed unless we receive the spin task
      if (gameController.spinTask !== undefined) {
        gameController.phase.step();
      }
    }

    _isPrePaid = gameController.spinTask?.data.isPrePaidGame;

    if (gameController.phase.once()) {
      _bonusesLanded = 0;
      logoIdleTimeline.pause();

      _reelsSpinning = [true, true, true, true, true];
      _symbolCallbackFired = [];

      let _positions = gameController.spinTask.data.resultPanel.reelList.map(
        function (reel, index) {
          return reel.symbols.map(function (curr) {
            return curr.value;
          });
        }
      );

      // we need to have a random symbol as the first below which we can drop
      // off the symbol grid when new symbols all cascade in
      let randomBelow = [];
      let allowedSymbols = [0, 1, 2, 3, 4, 5, 6, 7]; // no 8 or 9 as we don't want wilds or a bonus to appear
      for (var i = 0; i < gameData.reels.length; i++) {
        randomBelow[i] = allowedSymbols[getRandom(allowedSymbols.length)];
      }

      let _symbolsAbove = [[0], [0], [0], [0], [0]];
      let _symbolsBelow = [
        [randomBelow[0]],
        [randomBelow[1]],
        [randomBelow[2]],
        [randomBelow[3]],
        [randomBelow[4]],
      ];

      gameController.calcLandingAnims();

      let localRNG = gameController.spinTask?.data.localRng;
      if (localRNG !== undefined && localRNG !== null) {
        rng.seed(localRNG);
      }

      slotMachine.dropInitialSymbols(_symbolsAbove, _positions, _symbolsBelow);

      gameController.addOversizedSymbols();
    }

    if (gameController.phase.once()) {
      gameController._receivedResponse = true;
    }

    if (gameController.phase.hold()) {
      var spinComplete = true;
      for (
        var spinningIdx = 0;
        spinningIdx < _reelsSpinning.length;
        spinningIdx++
      ) {
        spinComplete = spinComplete && !_reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        gameController.phase.step();
        gameController._receivedResponse = false;
      }
    }

    // wait for all landing anims to finish playing
    if (gameController.phase.hold()) {
      let anyPlaying = false;
      for (var i = 0; i < _landedAnimsPlaying.length; i++) {
        let reelID = _landedAnimsPlaying[i][0];
        let row = _landedAnimsPlaying[i][1];

        let animStrip = resourceManager.get(
          reelManager.reels[reelID].linkedAnimations[0].name
        );
        if (animStrip.isAnimationPlaying(row)) {
          anyPlaying = true;
        }
      }

      // all landing anims finished - hide them away
      if (!anyPlaying) {
        for (var i = 0; i < _landedAnimsPlaying.length; i++) {
          let reelID = _landedAnimsPlaying[i][0];
          let row = _landedAnimsPlaying[i][1];

          let animStrip = resourceManager.get(
            reelManager.reels[reelID].linkedAnimations[0].name
          );
          animStrip.hideAnimation(row);
        }

        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      messageBox.clearMessage();

      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  gameController.RNG = function () {
    const m = 0x80000000;
    const a = 1664525;
    const c = 1013904223;

    let state;

    this.seed = function (newSeed) {
      let seedToUse = newSeed;

      if (typeof newSeed === "string") {
        let hash = 0;
        for (let i = 0; i < newSeed.length; i++) {
          hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
          hash = hash & hash;
        }
        seedToUse = Math.abs(hash);
      }
      state = seedToUse ? seedToUse : 0;
    };

    this.seed(0);

    this.nextInt = function () {
      state = (a * state + c) % m;
      return state;
    };

    this.nextFloat = function () {
      return this.nextInt() / (m - 1);
    };
  };

  // handle the anims on landing - cascadeInfiniReels calls this callback
  // then we match up if it's a valid bonus symbol to play anim/sound
  gameController.onSymbolLandedCallback = function (landedReel, landedRow) {
    var bonusLanded = false;

    // check that we have't already fired this callback ( can be retriggered doing a slam stop )
    for (var i = 0; i < _symbolCallbackFired.length; i++) {
      var firedReel = _symbolCallbackFired[i][0];
      var firedRow = _symbolCallbackFired[i][1];

      // if we've already fired this callback don't do it again
      if (landedReel === firedReel && landedRow === firedRow) {
        return;
      }
    }

    // we've got here so this must be the first time we've fired this callback - add to array
    _symbolCallbackFired.push([landedReel, landedRow]);

    // // play landing anims as required
    // for (var i = 0; i < _landedAnimsPlaying.length; i++) {
    //   var reel = _landedAnimsPlaying[i][0];
    //   var row = _landedAnimsPlaying[i][1];

    //   if (landedReel === reel && landedRow === row) {
    //     const symbolID =
    //       gameController.spinTask.data.resultPanel.reelList[reel].symbols[
    //         landedRow
    //       ].value;
    //     if (symbolID === 12) {
    //       soundManager.play(_spinBonusSounds[_bonusesLanded]);
    //       _bonusesLanded++;
    //     }

    //     var animStrip = resourceManager.get(
    //       reelManager.reels[reel].linkedAnimations[0].name
    //     );
    //     if (gameController.getSymbolFromID(symbolID).landAnim !== undefined) {
    //       animStrip.playAnimation(
    //         landedRow,
    //         gameController.getSymbolFromID(symbolID).landAnim
    //       );
    //       gameController.hideSymbolBehindAnimStrip(landedReel, landedRow, 250);
    //     }
    //     bonusLanded = true;
    //   }
    // }
    if (gameController.phase.hold()) {
      let anyPlaying = false;
      for (var i = 0; i < _landedAnimsPlaying.length; i++) {
        let reelID = _landedAnimsPlaying[i][0];
        let row = _landedAnimsPlaying[i][1];

        let animStrip = resourceManager.get(
          reelManager.reels[reelID].linkedAnimations[0].name
        );
        if (animStrip.isAnimationPlaying(row)) {
          anyPlaying = true;
        }
      }

      // all landing anims finished - hide them away
      if (!anyPlaying) {
        for (var i = 0; i < _landedAnimsPlaying.length; i++) {
          let reelID = _landedAnimsPlaying[i][0];
          let row = _landedAnimsPlaying[i][1];

          let animStrip = resourceManager.get(
            reelManager.reels[reelID].linkedAnimations[0].name
          );
          animStrip.hideAnimation(row);
        }

        gameController.phase.step();
      }
    }
  };

  gameController.getSymbolFromID = function (id) {
    const symbols = resourceManager.getConfiguration().symbols;
    for (let symbolName in symbols) {
      if (symbols.hasOwnProperty(symbolName) && symbols[symbolName].ID === id) {
        return symbols[symbolName];
      }
    }
    console.log("⚠️ Symbol not found by TopReel.js getSymbolFromID: ", id);
  };

  // Here we amend the layering for any oversized symbols so they're always on top
  gameController.addOversizedSymbols = function () {
    for (var l = 0; l < 3; l++) {
      for (let i = 0; i < 5; i++) {
        if (gameData.reels[i].symbolData[l].symbolId >= 8) {
          gameData.reels[i].overlayOversizedSymbols(l);
        }
      }
    }
  };

  gameController.calcLandingAnims = function () {
    _landedAnimsPlaying = [];
    var symbolID = null;

    for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
      for (var i = 0; i < 3; i++) {
        symbolID =
          gameController.spinTask.data.resultPanel.reelList[reelID].symbols[i]
            .value;
        _landedAnimsPlaying.push([reelID, i, symbolID]);
      }
    }
  };

  gameController.hideSymbolBehindAnimStrip = function (reel, row, duration) {
    const updatedSymbolOrder = gameController.getUpdatedSymbolOrder(reel);
    const symbol = resourceManager.get(
      "slotContainer:reelContainer:reel" +
        reel +
        ":symbolContainer:symbol" +
        updatedSymbolOrder[row] +
        ":symbol"
    );
    symbol.visible = false;
    timerManager.addTimer(duration, undefined, function () {
      symbol.visible = true;
      gameController.hideSingleSymbolAnim(reel, row);
    });
  };

  // when reel has landed all symbols - mark as no longer spinning
  gameController.onSpinCompleteBase = function (reelID) {
    _reelsSpinning[reelID] = false;
  };

  gameController.stateMachine.addState("REELS_SPINNING", function () {
    if (gameController.phase.enter()) {
      _reelsSpinning = [true, true, true, true, true];
    }

    if (gameController.phase.once()) {
    }

    if (gameController.phase.exit()) {
      messageBox.clearMessage();

      // If the game has aborted the spin task will be undefined
      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  gameController.stateMachine.addState("PAYWINS", function () {
    if (gameController.phase.once()) {
      _animWinsFinished = false;

      winlineAnimationController.startWinlineAnimations(
        _payWinsEvent.data,
        function () {
          _animWinsFinished = true;
        }
      );

      gameController.playWinSound();
    }

    if (gameController.phase.hold()) {
      if (_animWinsFinished) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      gameData.winningsText.show(true, 0);
      gameData.winningsText.resetMultiplierPosition();
      gameData.winningsText.setMultiplier(_payWinsEvent.data.multiplier);
      soundManager.play(
        _payWinsEvent.data.multiplier > 1
          ? "winMultiplierCrash"
          : "winTextAppear"
      );

      soundManager.play("winCountUp");
    }

    // grow to size and count up
    if (gameController.phase.timed(350)) {
      var appearProgress = Math.min(0.5 + gameController.phase.Progress, 1);
      gameData.winningsText.setScale(appearProgress);
      gameData.winningsText.alpha = appearProgress;
      gameData.winningsText.setText(
        Math.floor(
          gameController.phase.Progress *
            0.5 *
            _payWinsEvent.data.totalLineWinningsNonMultiplied
        )
      );
    }

    if (gameController.phase.once()) {
      gameData.winningsText.alpha = 1;
      gameData.winningsText.setScale(1);
    }

    if (gameController.phase.timed(350)) {
      var appearProgress = Math.min(0.5 + gameController.phase.Progress, 1);
      gameData.winningsText.setText(
        Math.floor(
          appearProgress * _payWinsEvent.data.totalLineWinningsNonMultiplied
        )
      );

      if (_payWinsEvent.data.multiplier > 1) {
        if (_skipWin) {
          gameController.phase.step();
        } else {
          gameData.winningsText.setMultiplierScale(
            gameController.phase.Progress
          );
        }
      }
    }

    if (gameController.phase.once()) {
      soundManager.stop("winCountUp");
      soundManager.play("winCountUpEnd");

      gameData.winningsText.setText(
        _payWinsEvent.data.totalLineWinningsNonMultiplied
      );

      if (_payWinsEvent.data.multiplier > 1) {
        gameData.winningsText.setMultiplierScale(1);
      }
    }

    if (gameController.phase.timed(300)) {
      if (_skipWin) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      if (_payWinsEvent.data.multiplier > 1) {
        gameData.winningsText.moveMultiplier(
          _payWinsEvent.data.totalLineWinnings,
          _skipWin
        );
      }
    }

    if (gameController.phase.timed(1500)) {
      if (_payWinsEvent.data.multiplier === 1) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.hold()) {
      if (_animWinsFinished) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(100)) {
      _animWinsFinished = true;
    }

    if (gameController.phase.once()) {
      gsap.to(gameData.winningsText, {
        duration: 0.5,
        pixi: { scaleX: 0, scaleY: 0 },
        ease: "back.in(2)",
      });
    }

    if (gameController.phase.timed(600)) {
    }

    if (gameController.phase.once()) {
      gameData.winningsText.scale.x = 1;
      gameData.winningsText.scale.y = 1;
      gameData.winningsText.show(false, true);

      gameController.stateMachine.switchState("PRE_POP_SYMBOLS");
    }
  });

  gameController.playWinSound = function (winType) {
    let lowWinSound =
      _lowWinSounds[Math.floor(Math.random() * _lowWinSounds.length)];
    let highWinSound =
      _highWinSounds[Math.floor(Math.random() * _highWinSounds.length)];

    if (winType) {
      musicManager.fadeOutAndInCurrentMusic();
      if (gameController.canCelebrate) {
        soundManager.play(highWinSound);
      } else {
        soundManager.play(lowWinSound);
      }
    } else {
      musicManager.fadeOutAndInCurrentMusic();
      if (
        _payWinsEvent.data.totalLineWinnings >
        resourceManager.getController("stakeController").CurrentStake
      ) {
        soundManager.play(highWinSound);
      } else {
        soundManager.play(lowWinSound);
      }
    }
  };

  gameController.skipWins = function () {
    _skipWin = true;
  };

  gameController.stateMachine.addState("PRE_POP_SYMBOLS", function () {
    if (gameController.phase.once()) {
      var winningLines = _payWinsEvent.data.winningLines;

      gameData.winningsMeter.countUp(_payWinsEvent.data.totalLineWinnings, 200);

      _poppingSymbols = [];
      for (var line = 0; line < winningLines.length; line++) {
        for (
          var symbolIndex = 0;
          symbolIndex < winningLines[line].positions.length;
          symbolIndex++
        ) {
          var position = winningLines[line].positions[symbolIndex];

          // Check if we have already added this symbol (multiple winlines may cross the same symbol)
          var found = false;
          for (var j = 0; j < _poppingSymbols.length && !found; j++) {
            found =
              _poppingSymbols[j].reel === position.reel &&
              _poppingSymbols[j].row === position.row;
          }

          if (!found) {
            // Add this to symbols we need to pop
            _poppingSymbols.push({ reel: position.reel, row: position.row });
          }
        }
      }
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");
      _payWinsEvent.leave();
    }
  });

  gameController.cancelAutoplay = function () {
    resourceManager.getController("autoplayController").cancel();
  };

  gameController.stateMachine.addState("DROP_SYMBOLS", function () {
    if (gameController.phase.enter()) {
      // Correctly position the win flashes to allow for rotation on mobiles
      gameController.positionWinFlashes();

      _lantern.increaseMultiplier();
    }

    if (gameController.phase.timed(1000)) {
    }

    if (gameController.phase.once()) {
      _wildAppearSymbols = [];
      _wildsToShow = [];
      _wildTypeToShow = -1;
      _dropsRemaining = 5;

      var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
      _reelToFrespinsBarFlying = 0;
      _popData = [];
      _allPopsComplete = false;

      gameController.positionWinFlashes();

      for (var reel = 0; reel < reelManager.reels.length; ++reel) {
        var popData = [];
        var totalDropping = 0;
        for (var row = 0; row < 3; ++row) {
          popData.push(_dropEvent.data.tumbleData[reel][row] !== 0);
          if (popData[row]) {
            totalDropping++;

            if (!_modifierEventTriggered) {
              _symbolDisappearAnims[reel][row].gotoAndPlay(0);
            }

            popAndFlyManager.addReelToFrespinsBar(
              reel,
              row,
              onReelToFrespinsBarComplete
            );
            _reelToFrespinsBarFlyingMax = ++_reelToFrespinsBarFlying;
          }
        }

        if (_dropEvent.data.cells.length > 0) {
          for (let i = 0; i < _dropEvent.data.cells.length; ++i) {
            let cell = _dropEvent.data.cells[i];
            if (cell.coord.reel === reel) {
              var row = cell.coord.offset;
              // We are also going to add a wild here, so pop symbol first
              // Note this is a fake pop, it isnt included in the drop data, we just simulate the pop
              if (!_modifierEventTriggered) {
                _symbolDisappearAnims[reel][row].gotoAndPlay(0);
              }

              var reel = cell.coord.reel;

              popAndFlyManager.addReelToFrespinsBar(
                reel,
                row,
                onReelToFrespinsBarComplete
              );
              _reelToFrespinsBarFlyingMax = ++_reelToFrespinsBarFlying;

              var reelObject = gameData.reels[reel];
              let wildToUse = -1;
              switch (cell.kind) {
                case 0:
                  wildToUse =
                    resourceManager.getConfiguration().symbols.Wild.ID;
                  break;
                case 1:
                  wildToUse =
                    resourceManager.getConfiguration().symbols.WildMultiBoost
                      .ID;
                  break;
                case 2:
                  wildToUse =
                    resourceManager.getConfiguration().symbols.WildStacked.ID;
                  break;
                case 3:
                  wildToUse =
                    resourceManager.getConfiguration().symbols.WildEachWay.ID;
                  break;
                default:
                  break;
              }

              reelObject.setReelSymbol(row, wildToUse);

              const wildAppearSymbol =
                reelObject.symbolSprites[
                  reelObject.Props.preappertureSymbols + row
                ];
              wildAppearSymbol.visible = false;
              _wildAppearSymbols.push(wildAppearSymbol);

              let wildToShow = { reel: reel, row: row };
              _wildsToShow.push(wildToShow);
              //If greater than 1 than must be a super wild
              if (_dropEvent.data.cells.length > 1) {
                _wildTypeToShow = 2;
              } else {
                _wildTypeToShow = cell.kind;
              }
            }
          }
        }

        _popData.push(popData);

        slotMachine.reels[reel].popSymbols(
          popData,
          _dropEvent.data.window[reel]
        );
      }

      soundManager.play("explode" + Math.floor(Math.random() * 3));
    }

    if (gameController.phase.hold()) {
      // We are waiting for all symbols pops to fly to torch
      if (_allPopsComplete) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(300)) {
    }

    if (gameController.phase.once()) {
      if (_wildAppearSymbols.length > 0) {
        resourceManager
          .get("wildSymbolAnimator:wildSymbolAnimator")
          .playWilds(_wildsToShow, _wildTypeToShow);
      }
    }

    if (gameController.phase.hold()) {
      if (
        !resourceManager
          .get("wildSymbolAnimator:wildSymbolAnimator")
          .wildsActive()
      ) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // Drop symbols
      const tempPopData = _popData;
      let delayTime = 10;
      let delayIndex = 0;

      _modifierEventTriggered = false;

      _popData = [];

      for (var i = 0; i < tempPopData.length; i++) {
        gameData.reels[i].dropSymbols(
          delayTime * delayIndex,
          tempPopData[i],
          onDropComplete
        );

        // Only set a delay on the next reel if this one had a drop
        if (tempPopData[i][0] || tempPopData[i][1] || tempPopData[i][2]) {
          delayIndex++;
        }
      }

      for (let reel = 0; reel < reelManager.reels.length; ++reel) {
        if (tempPopData[reel] !== undefined) {
          for (let row = 0; row < 3; ++row) {
            if (tempPopData[reel][row]) {
              gameData.reels[reel].showSymbol(row, true);
            }
          }
        }
      }

      gameController.addOversizedSymbols();
    }

    if (gameController.phase.exit()) {
    }
  });

  gameController.stateMachine.addState("PAY_TO_WINNINGS", function () {
    // Hide any bonus syms we've added, as they appear on top of the winnings view
    for (var i = 0; i < _landedAnimsPlaying.length; i++) {
      let reelID = _landedAnimsPlaying[i][0];
      let row = _landedAnimsPlaying[i][1];

      let animStrip = resourceManager.get(
        reelManager.reels[reelID].linkedAnimations[0].name
      );
      animStrip.hideAnimation(row);
      animStrip.removeChildren();
    }

    //??AFTER All symbols have animated and winning text has gone, and cascade round is over.
    if (gameController.phase.once()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("payToWinnings");
      }

      let isBigWin = _bigWin.willTriggerBigWin(
        _popAndDropCompleteEvent.data.winnings
      );

      if (isBigWin && !freespins.inFreespins) {
        _bigWin.setBigWinActive(true);
        timerManager.addTimer(1000, undefined, function () {
          _bigWin.start(_popAndDropCompleteEvent.data.winnings, function () {});
        });
      }
    }

    if (gameController.phase.hold()) {
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (
      gameController.canCelebrate &&
      !freespins.inFreespins &&
      !_bigWin.willTriggerBigWin(_popAndDropCompleteEvent.data.winnings)
    ) {
      if (gameController.phase.timed(200)) {
      }
      if (gameController.phase.once()) {
        gameController.dimAllReels(true);

        messageBox.show(true);
        messageBox.setMessage("t_totalRoundWin", "");
        gameData.winningsText.show(true, 0);
        soundManager.play("winCountUp");
      }

      // grow to size and count up
      if (gameController.phase.timed(1200)) {
        var appearProgress = Math.min(0.5 + gameController.phase.Progress, 1);
        gameData.winningsText.setScale(appearProgress);
        gameData.winningsText.alpha = appearProgress;
        gameData.winningsText.setText(
          Math.floor(gameController.phase.Progress * _totalWinnings)
        );
      }

      if (gameController.phase.once()) {
        soundManager.stop("winCountUp");
        soundManager.play("winCountUpEnd");
        gameData.winningsText.setScale(1);
        gameData.winningsText.alpha = 1;
        gameData.winningsText.setText(_totalWinnings);
      }

      if (gameController.phase.timed(1400)) {
      }

      if (gameController.phase.once()) {
        messageBox.show(false);
        gameData.winningsText.show(false);

        gameController.dimAllReels(false);
      }
    }

    if (gameController.phase.once()) {
      if (freespins.inFreespins) {
        musicManager.freeSpinsNextLevel();
      }

      soundManager.stop("winCountUp");

      gameData.winningsMeterTitle.visible = true;
    }
    if (gameController.phase.timed(100)) {
    }
    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");
    }
    if (gameController.phase.exit()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("enabled");
      }
      _popAndDropCompleteEvent.leave();
    }
  });

  gameController.getSymbolWorldPosition = function (symbol) {
    const symbolLocalPosition = symbol.transform.position;
    const symbolParent = symbol.parent;

    const convertedPosition = symbolParent.toGlobal(symbolLocalPosition);
    const finalPosition = resourceManager
      .get("slotContainer")
      .toLocal(convertedPosition);

    return finalPosition;
  };

  gameController.stateMachine.addState("END_GAME", function () {
    // _topReelSpinCount = 0;
    if (gameController.phase.once()) {
      logoIdleTimeline.play();

      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("enabled");
      }
      gameController._inRecovery = false;
      gameController.inRecovery = false;
      gdk.endGame(function () {
        gameController.stateMachine.switchState("WAIT_FOR_START");
      });
    }
  });

  gameController.initialise = function () {
    // Create a new instance of the RNG
    rng = new gameController.RNG();

    // resourceManager.getContainer("soundTrack").visible = true;

    _bigWin = resourceManager.get("bigWin");
    _bigWin.init();
    freespins.initialise();
    _lantern = resourceManager.get("lanternMultiplier:lantern");

    _freeSpinsMeter = resourceManager.get("freeSpinsMeter");
    _freeSpinsMeter.initialise();

    titleAnim = resourceManager.get("logoContainer:logo");
    titleAnim.visible = true;

    logoIdleTimeline = gsap.timeline({ repeat: -1 }).call(
      () => {
        titleAnim.gotoAndPlay(0);
      },
      undefined,
      "<+=8"
    );
    logoIdleTimeline.play();

    gameController.timeScale = 1;
    document.addEventListener("keydown", game.onKeyDown);

    const slamStopButton = resourceManager.get(
      "buttonContainer:buttonBar:slamStopButton"
    );
    slamStopButton.canEnableBase = slamStopButton.canEnable;
    slamStopButton.canEnable = function () {
      return this.canEnableBase() && gameController._receivedResponse;
    };

    const volumeButton = resourceManager.get("buttonContainer:buttonBar:mute");
    volumeButton.canShowBase = volumeButton.canShow;
    volumeButton.canShow = function () {
      return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
    };

    const canEnableSound = settingsMenu.buttons.btnSound.visible;
    const soundButton = resourceManager.get(
      "systemSettings:systemSettingsBox:settingSound"
    );
    soundButton.setActive(canEnableSound);

    resourceManager.get(
      "buttonContainer:buttonBar:autoplayButton:glow"
    ).visible = false;

    gameController.setupSymbolDisappearAnims();

    musicManager.onGameLoaded();

    gameController.onOrientationChange();
  };

  gameController.globalHelperGetStake = function () {
    let stake = resourceManager.getController("stakeController").BaseStake;
    if (gameController.inBuyABonus) {
      stake *= 100;
    }
    return stake;
  };

  gameController.positionWinFlashes = function () {
    for (var i = 0; i < 5; i++) {
      for (var j = 0; j < 3; j++) {
        var reel = i;
        var row = j;

        if (_symbolDisappearAnims.length > 0) {
          _symbolDisappearAnims[reel][row].gotoAndStop(0);

          const updatedSymbolOrder = gameController.getUpdatedSymbolOrder(reel);
          const targetSymbol = gameController.getSymbolWorldPosition(
            resourceManager.get(
              "slotContainer:reelContainer:reel" +
                reel +
                ":symbolContainer:symbol" +
                updatedSymbolOrder[row] +
                ":symbol"
            )
          );
          let xPos = targetSymbol.x;
          let yPos = targetSymbol.y;

          if (
            layoutController.getCurrentLayout() === "portrait_mobile" ||
            layoutController.getCurrentLayout() === "portrait_default"
          ) {
            xPos -= 10;
            yPos += 85;
          } else if (
            layoutController.getCurrentLayout() === "landscape_mobile"
          ) {
            xPos += 30;
            yPos += 20;
          }

          _symbolDisappearAnims[reel][row].scale.set(1);
          _symbolDisappearAnims[reel][row].position.set(xPos, yPos);
        }
      }
    }
  };

  gameController.onOrientationChange = function () {
    gameController.positionWinFlashes();

    // const panel = resourceManager.get(
    //   "buttonContainer:buttonBar:buyBonusButton:sidePanel"
    // );

    // if (panel) {
    //   if (systemData.isLandscape && !freespins.inFreespins) {
    //     panel.visible = true;
    //   } else {
    //     panel.visible = false;
    //   }
    // }
  };

  gameController.onGameSkipped = function (stakeInfo) {
    // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
    // so we have a new message and we do that here
    // ideally this should be in the libs somewhere!!
    const stakeController = resourceManager.getController("stakeController");

    // now we can have bonus buys on different stakes compared to normal
    // os 1st lets make sure the stake is valid for BASIC
    const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
    if (stakeIndex === -1) {
      // the bonus buy stake isnt in the BASIC stake
      // so we need to use the default
      // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
      stakeInfo.baseStake = stakeController.BaseStake;
    }

    stakeController.requestChangeStake(stakeInfo.baseStake);

    if (gameData.encoreEnabled) {
      resourceManager.getContainer(
        "goldenBetBackgroundContainer"
      ).visible = true;
    }
  };

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe("common:GameCompleteEvent", preGameComplete);
  messageBus.subscribe("autoplay:started", autoplayStarted);
  messageBus.subscribe("autoplay:ended", autoplayEnded);
  messageBus.subscribe("spinner:SpinEvent", gameController.onSpinEvent);
  messageBus.subscribe("spinner:WinningLinesEvent", doPayWins);
  messageBus.subscribe("Game:DropEvent", onDropEvent);
  messageBus.subscribe("Game:PopAndDropComplete", onPopAndDropComplete);
  //messageBus.subscribe("Game:PopAndDropComplete", hideBonusSyms);
  // messageBus.subscribe("Game:RespinEvent", onRespinIntro);
  // messageBus.subscribe("Game:RespinEventDead", onRespinEvent);
  messageBus.subscribe("common:RecoverGame", recoverGame);
  messageBus.subscribe("common:JackpotGame", jackpotGame);
  messageBus.subscribe("platform:startNextGame", startGame);
  messageBus.subscribe("common:AbortGame", onAbortGame);
  messageBus.subscribe("Game:ExtraSpinsRemaining", onExtraSpinsRemaining);
  messageBus.subscribe("common:GameSkipped", gameController.onGameSkipped);

  //messageBus.subscribe("Game:ModifierEvent", hideBonusSyms );
  messageBus.subscribe("Game:FreeSpinsAwardEvent", onFeatureAnnounced);
  messageBus.subscribe("Game:FreeSpinsEndEvent", onFeatureEnded);

  messageBus.subscribe("Game:ModifierEvent", onModifierEvent);

  Reflex.addToUpdate(update.bind(gameController));
  Reflex.registerEventHandler(
    "orientationChange",
    gameController.onOrientationChange
  );

  messageBus.subscribe("common:PromotionStarted", onPromotionStarted);
  messageBus.subscribe("common:PromotionEnded", onPromotionEnded);

  gameController.canCelebrate = true;

  gameController.stateMachine.switchState("WAIT_FOR_START");

  Object.seal(gameController);
  return gameController;
})();
